"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const gui_debug_1 = require("./gui_debug");
const sdk_base_1 = require("./sdk_base");
class SdkDebug extends sdk_base_1.Sdk {
    constructor() {
        var _a;
        super({
            fps: false,
            trackables: false,
            allowFaceToFaceMode: false,
        });
        // Watch for destroyed events & keep local reference in sync
        gui_debug_1.DebugGUI.onGUIDestroyed.subscribe(() => (this.gui = undefined));
        // Watch for Konami Code, then create new GUI if not already shown
        this.listenForKonamiCode().subscribe(() => { var _a; return ((_a = this.gui) !== null && _a !== void 0 ? _a : (this.gui = new gui_debug_1.DebugGUI(this))); });
        const urlParams = new URLSearchParams(window.location.search);
        const debug = urlParams.get('debug');
        if (!debug)
            return;
        const debugFlags = debug.split(',');
        for (const flag of debugFlags) {
            switch (flag) {
                case 'gui': // Intentional fallthrough
                case 'true':
                    (_a = this.gui) !== null && _a !== void 0 ? _a : (this.gui = new gui_debug_1.DebugGUI(this));
            }
        }
    }
    get allowFaceToFaceMode() {
        return this.flags.allowFaceToFaceMode;
    }
    set allowFaceToFaceMode(value) {
        this.updateFlag('allowFaceToFaceMode', value);
    }
    get fps() {
        return this.flags.fps;
    }
    set fps(value) {
        this.updateFlag('fps', value);
    }
    get trackables() {
        return this.flags.trackables;
    }
    set trackables(value) {
        this.updateFlag('trackables', value);
    }
    listenForKonamiCode() {
        const KONAMI = [
            'ArrowUp',
            'ArrowUp',
            'ArrowDown',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'ArrowLeft',
            'ArrowRight',
            'b',
            'a',
        ].join();
        const konamiObservable = (0, rxjs_1.fromEvent)(document, 'keydown').pipe((0, operators_1.map)((v) => v.key), (0, operators_1.bufferCount)(10, 1), (0, operators_1.filter)(code => code.join() === KONAMI));
        return konamiObservable;
    }
}
// This is a singleton, default export is valid here.
// eslint-disable-next-line import/no-default-export
exports.default = new SdkDebug();
//# sourceMappingURL=sdk_debug.js.map